export function selectActiveOrganizationId({ userId, allowedIds, storedOrgId, storedUserId }) {
  const allowed = Array.isArray(allowedIds) ? allowedIds.filter(Boolean) : []
  if (!userId) return null
  if (storedOrgId && storedUserId === userId && allowed.includes(storedOrgId)) return storedOrgId
  return allowed[0] || null
}

export function isPlatformAdminAccount(user) {
  const role = String(user?.role || '').toLowerCase()
  const perms = Array.isArray(user?.permissions) ? user.permissions : []
  return role === 'admin' || perms.includes('all') || perms.includes('admin')
}

export function resolveSettingsOrganizationId({
  explicitOrgId,
  membershipIds,
  catalogIds,
  activeOrgId,
  isPlatformAdmin,
  catalogLoaded,
}) {
  const membership = Array.isArray(membershipIds) ? membershipIds.filter(Boolean) : []
  const catalog = Array.isArray(catalogIds) ? catalogIds.filter(Boolean) : []
  const explicit = explicitOrgId ? String(explicitOrgId) : ''
  if (explicit) {
    if (membership.includes(explicit)) return explicit
    if (isPlatformAdmin && (!catalogLoaded || catalog.length === 0 || catalog.includes(explicit))) return explicit
    return null
  }
  if (activeOrgId && membership.includes(activeOrgId)) return activeOrgId
  return null
}

const USER_ID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i

export function assignmentLookup(value) {
  const raw = String(value || '').trim()
  if (!raw) return null
  if (USER_ID_PATTERN.test(raw)) return { userId: raw }
  if (raw.includes('@')) return { email: raw }
  return { username: raw }
}

export function acceptOrgView(ticket, current) {
  if (!ticket || !current) return false
  if (ticket.generation !== current.generation) return false
  if (ticket.userId !== current.userId) return false
  if (ticket.orgId !== current.orgId) return false
  return true
}
